/**
 * @deprecated Use `TextStyleSize` from `@sirius/typography`
 * (`'s' | 'm' | 'l'` for the paragraph category). The values map as
 * `small -> s`, `medium -> m`, `large -> l`.
 */
export const PARAGRAPH_SIZES = ['small', 'medium', 'large'] as const;

/**
 * @deprecated Use `TextStyleSize` from `@sirius/typography`
 * (`'s' | 'm' | 'l'` for the paragraph category).
 */
export type ParagraphSize = (typeof PARAGRAPH_SIZES)[number];
